<template>
  <v-container
    fluid
    class="upload px-5"
  >
    <v-card
      class="upload__card pa-5 pt-10 pb-8 transition-swing"
      data-test="dropzone"
      :class="{ 'upload__card--dragover': dragover }"
      :elevation="dragover ? 6 : 0"
      @drop.prevent="saveFiles($event.dataTransfer.files)"
      @dragover.prevent="dragover = true"
      @dragenter.prevent="dragover = true"
      @dragleave.prevent="dragover = false"
      @click="onUploadClick"
      @mouseover="hovered = true"
      @mouseleave="hovered = false"
    >
      <v-card-text class="upload__content">
        <v-row
          class="d-flex flex-column"
          dense
          align="center"
          justify="center"
        >
          <v-icon
            :class="{
              'upload__icon--dragover': dragover,
              'upload__icon--hovered': hovered,
            }"
            class="cloud-upload upload__icon mb-5"
            :style="{ 'color': dragover || hovered ? appColor.secondary : appColor.textDark }"
            size="70"
          >
            bi-cloud-upload
          </v-icon>
          <p
            class="upload__text"
            :style="{ 'color': appColor.textDark }"
          >
            {{ text }}
          </p>
        </v-row>
      </v-card-text>
      <input
        v-show="false"
        ref="inputUpload"
        type="file"
        data-test="input"
        :accept="formats"
        multiple
        @change="saveFiles($event.target.files)"
      >
    </v-card>
  </v-container>
</template>

<script>
export default {
  name: 'FilesUpload',

  props: {
    text: {
      type: String,
      required: true,
      default: 'Переместите файлы(-ы) или нажмите, чтобы выбрать.'
    },
    formats: {
      type: String,
      required: false,
      default: ''
    }
  },

  data () {
    return {
      dragover: false,
      hovered: false,
      appColor: this.$appConfig.color
    }
  },

  methods: {
    saveFiles (files) {
      if (files?.length) {
        this.$emit('saveFiles', files)
        this.dragover = false
      }
    },

    onUploadClick () {
      this.$refs.inputUpload.click()
    }
  }
}
</script>

<style lang="scss" scoped>
  .upload {
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;

    &__card {
      width: 600px;
      background-color: white;
      border-radius: 30px !important;
      text-align: center;
      color: $color-main-dark !important;

      &--dragover {
        transform: scale(1.04);
      }

      &:before {
        border-radius: 30px;
      }
    }

    &__content {
      pointer-events: none;
    }

    &__icon {
      &--hovered,
      &--dragover {
        color: $color-secondary;
      }
    }

    &__text {
      font-weight: bold;
      user-select: none;

      @media(max-width: $cp-laptop-breakpoint) {
        font-size: 0.8rem;
      }
    }
  }
</style>
